import Progress from 'semantic-ui-react/dist/commonjs/modules/Progress';
import '@purple/semantic-ui-purple-theme/components/progress.css';

export default Progress;
